import type { PaginatedResponse } from '@/types'

export type PaymentStatus = 'pending' | 'paid' | 'rejected'

/** Значение фильтра: refunded — признак возврата, а не колонка status */
export type PaymentStatusFilter = PaymentStatus | 'refunded'

/** Подписка, оплаченная платежом — по ней решаем, спрашивать ли об отмене */
export interface AdminPaymentSubscription {
  id: number
  is_active: boolean
  expires_at: string | null
}

export interface AdminPayment {
  id: number
  user: { id: number; name: string | null }
  plan: { id: number; name: string | null }
  amount: string
  status: PaymentStatus
  is_refunded: boolean
  subscription?: AdminPaymentSubscription | null
  method: string
  proof_file: string | null
  refunded_at: string | null
  refunded_by: number | null
  created_at: string | null
}

export interface AdminPaymentFilters {
  user_id?: number
  status?: PaymentStatusFilter
  from?: string
  to?: string
  page?: number
  per_page?: number
}

export interface AdminContractTransaction {
  id: number
  contract_id: number
  teacher: { id: number; name: string | null } | null
  student: { id: number; name: string | null } | null
  type: string
  direction: 'credit' | 'debit'
  amount: string
  currency: string
  source: string
  status: string
  description: string | null
  meta: Record<string, unknown> | null
  created_at: string | null
}

export interface AdminContractTransactionFilters {
  user_id?: number
  type?: string
  status?: string
  from?: string
  to?: string
  page?: number
  per_page?: number
}

export interface AdminBalanceTransaction {
  id: number
  user: { id: number; name: string | null }
  type: string
  direction: 'credit' | 'debit'
  amount: string
  currency: string
  balance_after: string
  description: string | null
  created_at: string | null
}

export interface AdminBalanceTransactionFilters {
  user_id?: number
  type?: string
  direction?: 'credit' | 'debit'
  from?: string
  to?: string
  page?: number
  per_page?: number
}

export type AdminPaymentsPage = PaginatedResponse<AdminPayment>
export type AdminContractTransactionsPage = PaginatedResponse<AdminContractTransaction>
export type AdminBalanceTransactionsPage = PaginatedResponse<AdminBalanceTransaction>

export const PAYMENT_STATUSES: PaymentStatus[] = ['pending', 'paid', 'rejected']

/**
 * Значения селекта «Статус» в журнале платежей: к колонке status добавлен
 * признак возврата — на бэкенде это отдельная ветка фильтра (refunded_at),
 * а обычные статусы возвращённые платежи исключают.
 */
export const PAYMENT_STATUS_FILTERS: PaymentStatusFilter[] = [...PAYMENT_STATUSES, 'refunded']
export const CONTRACT_TX_TYPES = ['topup', 'lesson_payment', 'subscription_purchase', 'correction', 'refund'] as const
export const BALANCE_TX_TYPES = ['topup', 'adjustment', 'tts_charge', 'refund', 'subscription_charge'] as const
